var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-tooltip",class:[{ active:  this.$store.state.tooltips[this.tool] }]},[_vm._v("\n    "+_vm._s(this.tip)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }